/**
 * Get uniba show servizi online action
 * @module src/actions/getUngetUnibaShowServiziOnlineibaServiziOnline
 */
export const GET_UNIBA_SHOWSERVIZIONLINE = 'GET_UNIBA_SHOWSERVIZIONLINE';

/**
 * Get uniba show servizi online.
 * @function getUnibaShowServiziOnline
 * @returns {Object} Get uniba show servizi online action.
 */
export function getUnibaShowServiziOnline(params) {
  return {
    type: GET_UNIBA_SHOWSERVIZIONLINE,
    request: {
      op: 'get',
      path: `/@getShowServiziOnlineUniba`,
      params: params,
    },
  };
}
